<template>
  <b-modal
    id="confirm-modal"
    ref="confirmModal"
    :title="confirmTitle"
    :class="{
      'no-title': !confirmTitle,
    }"
    @hide="resolveConfirm"
    v-model="toggleConfirm"
    hide-footer>
    <div v-html="confirmMsg"></div>

    <div class="mt-3 d-flex justify-content-end">
      <b-button
        type="button"
        variant="success"
        @click="$refs.confirmModal.hide('accept');">
        Yes
      </b-button>

      <b-button
        type="button"
        class="ml-3"
        variant="danger"
        @click="$refs.confirmModal.hide('deny');">
        No
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      confirmTitle: '',
      confirmMsg: '',
      toggleConfirm: false,
    };
  },
  methods: {
    resolveConfirm(event) {
      this.toggleConfirm = false;
      this.confirmTitle = '';
      this.confirmMsg = '';
      this.$root.$emit('hide-confirm', event.trigger);
    },
  },
  created() {
    this.$root.$on('show-confirm', (data) => {
      this.toggleConfirm = true;
      this.confirmTitle = data.title;
      this.confirmMsg = data.msg;
    });
  },
};
</script>

<style lang="scss">
.no-title {
  .modal {
    .modal-header {
      padding-top: .25rem;
      padding-bottom: .35rem;
      padding-right: .4rem;
    }
  }
}
</style>
